<template>
    <v-container fluid class="pa-0">
        <div v-if="wurf && wurfData">
            Wurfdetail für Wurf "{{ wurf }}" ist: Noch im Aufbau 😊
            <br />
            Sire: {{ this.wurfData.data.sire.name }} <br />
            Link:
            <router-link v-if="this.wuerfeStore.cats[this.wurfData.data.sire.name].own"
                :to="this.wuerfeStore.cats[this.wurfData.data.sire.name].link">{{
                    this.wuerfeStore.cats[this.wurfData.data.sire.name].link }} (own)</router-link>
            <a v-else :href="this.wuerfeStore.cats[this.wurfData.data.sire.name].link">{{
                this.wuerfeStore.cats[this.wurfData.data.sire.name].link }} (extern)</a>
            <br />
            Dam: {{ this.wurfData.data.dam.name }} <br />
            Link:
            <router-link v-if="this.wuerfeStore.cats[this.wurfData.data.dam.name].own"
                :to="this.wuerfeStore.cats[this.wurfData.data.dam.name].link">{{
                    this.wuerfeStore.cats[this.wurfData.data.dam.name].link }} (own) </router-link>
            <a v-else :href="this.wuerfeStore.cats[this.wurfData.data.dam.name].link">{{
                this.wuerfeStore.cats[this.wurfData.data.dam.name].link }} (extern)</a>
            <br />
            <router-link v-for="item in this.wuerfeStore.wuerfe" :key="item.id" :to="item.link">
                <div>
                    {{ item.title }}
                </div>
            </router-link>
            Wurf: {{ wurf }}
            {{ wurfData }}
            {{ this.wuerfeStore.wuerfe }}
            <br />
            <br />
            Offspring: {{ calculateOffspring(this.wuerfeStore.cats[this.wurfData.data.sire.name],
                this.wuerfeStore.cats[this.wurfData.data.dam.name]) }}
        </div>
        <div v-else>
            <wuerfe-view></wuerfe-view>
        </div>
    </v-container>
</template>

<script>
import { useWuerfeStore } from "../store/wuerfe"
import WuerfeView from "./WuerfeView.vue"

export default {
    components: {
        WuerfeView,
    },
    setup() {
        const wuerfeStore = useWuerfeStore();
        return { wuerfeStore };
    },
    created() {
        this.updateWurfData();
    },
    beforeUpdate() {
        this.updateWurfData();
    },
    methods: {
        updateWurfData() {
            let data = {};
            for (const wurf of this.wuerfeStore.wuerfe) {
                if (typeof (wurf.wurfId) === 'string' && (wurf.wurfId.toLowerCase() == this.wurf.toLowerCase())) {
                    data = wurf;
                }
            }
            this.wurfData = data;
        },
        calculateOffspring(sire, dam) {
            const compareArrays = (a, b) =>
                a.length === b.length &&
                a.every((element, index) => element === b[index]);

            const helperHighlevel = function (raw) {
                let res = {}

                const recIfTwo = raw.filter(gene => compareArrays(gene, [2, 2])).length;
                if (recIfTwo) {
                    res.recIfTwo = recIfTwo;
                }

                const carryIfOne = raw.filter(gene => compareArrays(gene, [2, 1])).length;
                if (carryIfOne) {
                    res.carryIfOne = carryIfOne;
                }

                const recIfOne = raw.filter(gene => compareArrays(gene, [2, 0])).length;
                if (recIfOne) {
                    res.recIfOne = recIfOne;
                }

                const dom = raw.filter(gene => compareArrays(gene, [1, 1])).length;
                if (dom) {
                    res.dom = dom;
                }

                const carry = raw.filter(gene => compareArrays(gene, [1, 0])).length;
                if (carry) {
                    res.carry = carry;
                }

                const rec = raw.filter(gene => compareArrays(gene, [0, 0])).length;
                if (rec) {
                    res.rec = rec;
                }



                return res
            }

            const helperRaw = function (sire, dam, attrib) {
                let results = [];
                for (const x of sire.genes[attrib]) {
                    for (const y of dam.genes[attrib]) {
                        results.push([x, y].sort().reverse());
                    }
                }
                return results;
            };
            const geneNames = [
                'agouti',
                'nondilution',
                'silver',
                'spotwhite',
                'mackerel',
                'white',
                'red',
            ];
            let results = {
                'raw': {},
                'highlevel': {}
            };

            for (const name of geneNames) {
                const res = helperRaw(sire, dam, name);
                results.raw[name] = res;
            }

            for (const name of geneNames) {
                results.highlevel[name] = helperHighlevel(results.raw[name]);
            }

            // Fix red highlevel
            results.highlevel.red = {
                'boys': {},
                'girls': {},
            }

            let redboys = 0;
            let blackboys = 0;
            let redgirls = 0;
            let blackgirls = 0;
            let bothgirls = 0;

            for (const red of dam.genes.red) {
                if (red) {
                    redboys += 1;
                } else {
                    blackboys += 1;
                }
            }
            for (const red of dam.genes.red) {
                if (red) {
                    if (sire.genes.red[0]) {
                        redgirls += 1;
                    } else {
                        bothgirls += 1;
                    }
                } else {
                    if (sire.genes.red[0]) {
                        bothgirls += 1;
                    } else {
                        blackgirls += 1;
                    }
                }
            }

            if (redboys) {
                results.highlevel.red.boys.red = redboys;
            }
            if (blackboys) {
                results.highlevel.red.boys.black = blackboys;
            }
            if (redgirls) {
                results.highlevel.red.girls.red = redgirls;
            }
            if (blackgirls) {
                results.highlevel.red.girls.black = blackgirls;
            }
            if (bothgirls) {
                results.highlevel.red.girls.both = bothgirls;
            }

            // Fix red genes

            return results
        }
    },
    props: [
        'wurf',
    ],
    data() {
        return {
            wurfData: {},
        }
    },
}
</script>

<style></style>
